import urlJoin from 'url-join';
import env from '../config/env';

export const urls = {
  auth: {
    checkSession: 'users/user',
    generateOTP: 'users/generateOTP',
    login: 'users/login',
    logout: 'users/logout',
  },
  passwordReset: {
    email: '/resetPasswordEmail',
    reset: '/resetPassword',
  },
  users: '/users',
  events: {
    root: '/events',
    event: '/event',
    delete: '/delete',
    share: '/share',
    geofence: '/geofence',
    language: '/languages',
    images: '/images',
  },
  cameras: {
    root: '/cameras',
    status: '/status',
    settings: {
      root: '/settings',
    },
  },
  get websocket() {
    return urlJoin(env.WS_PROTOCOL, env.BRIZI_API_AUTHORITY);
  },
  get baseAPIUrl() {
    if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
      return '/api';
    }
    return urlJoin(env.HTTP_PROTOCOL, env.BRIZI_API_AUTHORITY, 'api');
  },
  snapshots: {
    list: 'snapshots',
    ban: 'snapshots/ban',
    favorite: 'snapshots/favorite',
    delete: 'snapshots/delete',
    stats: 'snapshots/stats',
  },
  mapping: {
    root: '/mapping',
    download: '/download',
  },
  selfieCam: {
    config: 'selfieCam/event',
    event: 'selfieCam/event',
  },
  aiConcept: {
    root: 'ai-concept',
    models: 'ai-concept/models',
  },
};

export const buildURL = (...args) => urlJoin(urls.baseAPIUrl, ...args);

export const removeOrigin = (image) => {
  if (image) {
    if (image.includes('static-assets') || image.includes('app/assets')) {
      // if image is served from static files, removing origin will result with an invalid URL
      // and download will not work, by doing this the URL will have a different origin, file will
      // not be downloaded as an attachment, but link will be correct and will open in a new tab
      return image;
    }

    const { origin } = new URL(image);
    return image.replace(origin, '');
  }

  return image;
};
